import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4"
    >
      <div className="text-6xl font-bold text-slate-300">404</div>
      <h1 className="text-xl font-semibold mt-2">Page not found</h1>
      <p className="text-sm text-slate-500 mt-2">That route doesn&apos;t exist (yet).</p>
      <Button asChild className="mt-6">
        <Link to="/" data-testid="not-found-home-btn">Home</Link>
      </Button>
    </div>
  );
}
